import {
  PageLoading,
  Panel,
  PanelHeading,
  PanelSpacer,
  PanelRow,
  Label,
  BoldText,
  Link,
  PanelDialog,
  StatusIndicator,
} from "@backslashbuild/pp-ui";
import React from "react";
import { useGet } from "./api";
import { isTextNullOrEmpty, utcToLocalText } from "./utils";
import AgencyCreditForm from "./AgencyCreditForm";
import { subscribe, unsubscribe } from "./pubSub";
import { useAddViewingToHistory } from "../history/api";

export default function AgencyCreditPanel({ id }) {
  const [editAgencyDetails, setEditAgencyDetails] = React.useState(null);
  const { data, loading, error, refetch } = useGet(id);
  const addViewingToHistory = useAddViewingToHistory({ itemType: "agency" });

  React.useEffect(() => {
    if (data != null && data.isSuccess) {
      recordViewing();
    }
  }, [id, data?.isSuccess]);

  React.useEffect(() => {
    subscribe("agency.agencyCredit.updated", refetch);
    return () => unsubscribe("agency.agencyCredit.updated", refetch);
  }, [id]);

  if (loading) return <PageLoading />;

  function recordViewing() {
    const fullName = `${data?.value?.name}`;
    const url = `agency/${id}`;

    const body = {
      itemId: id,
      type: "[agency]",
      name: fullName,
      url: url,
    };
    addViewingToHistory(body);
  }

  function handleRender() {
    if (!isTextNullOrEmpty(error)) return <div>{String(error)}</div>;

    if (data != null && !data.isSuccess) {
      return data.errors.map((error) => <div>{error}</div>);
    }

    return (
      <>
        <PanelRow>
          <Label label="Credit Health Status">
            <BoldText>{data?.value?.creditHealthStatus}</BoldText>
          </Label>
        </PanelRow>
        <PanelRow>
          <Label label="Credit Terms">
            <BoldText>{data?.value?.creditTerms}</BoldText>
          </Label>
        </PanelRow>
        <PanelRow>
          <Label label="Credit Rating">
            <BoldText>{data?.value?.creditRating}</BoldText>
          </Label>
        </PanelRow>
        <PanelRow>
          <Label label="Credit Limit">
            <BoldText>{data?.value?.creditLimit}</BoldText>
          </Label>
        </PanelRow>
        <PanelRow>
          <Label label="Credit Check Date">
            <BoldText>{utcToLocalText(data?.value?.creditCheckDate)}</BoldText>
          </Label>
        </PanelRow>
        <PanelRow>
          <Label label="Credit Check Company Number Used">
            <BoldText>{data?.value?.creditCheckCompanyNumberUsed}</BoldText>
          </Label>
        </PanelRow>
      </>
    );
  }

  return (
    <>
      <Panel>
        <PanelHeading rightAction={<Link onClick={() => setEditAgencyDetails(id)}>Edit</Link>}>
          Agency Credit
        </PanelHeading>
        <PanelSpacer />
        {handleRender()}
        <PanelSpacer />
      </Panel>
      <PanelDialog open={editAgencyDetails}>
        <PanelHeading>Edit agency credit</PanelHeading>
        {editAgencyDetails && (
          <AgencyCreditForm id={editAgencyDetails} onClose={() => setEditAgencyDetails(null)} />
        )}
      </PanelDialog>
    </>
  );
}
